import {facebookMessageConfirmOrderActions as actions} from './_actions'
import {facebookMessageConfirmOrderInitialState} from './_initstate'

export const FacebookMessageConfirmOrderReducer = (state, action) => {
  switch (action.type) {

    case actions.MESSAGE_CONFIRM_LIST_UPDATE:
      return {
        ...state,
        pages: {
          ...state.pages,
          list: action.payload?.list,
        },
      }

    case actions.MESSAGE_CONFIRM_LOADING_UPDATE:
      return {
        ...state,
        pages: {
          ...state.pages,
          loading: action.payload?.loading,
        },
      }

    case actions.MESSAGE_CONFIRM_MODAL_STATUS:
      return {
        ...state,
        modal: {
          ...state.modal,
          confirmStatus: {
            ...state.modal.confirmStatus,
            data: action.payload.data,
            open: action.payload.open,
          },
        },
      }
    case actions.MESSAGE_CONFIRM_GET_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          content_message: action.payload.content_message || state.detail.samples,
          status: action.payload.status,
        }
      }
    case actions.MESSAGE_CONFIRM_CHANGE_MESSAGE:
      return {
        ...state,
        detail: {
          ...state.detail,
          content_message: action.payload,
          reset: false
        }
      }
    case actions.MESSAGE_CONFIRM_CHANGE_STATUS:
      return {
        ...state,
        detail: {
          ...state.detail,
          status: action.payload
        }
      }
    case actions.VALIDATE_MESSAGE_CONFIRM:
      return {
        ...state,
        detail: {
          ...state.detail,
          validate: action.payload
        }
      }
    case actions.MESSAGE_CONFIRM_RESET_CONTENT:
      return {
        ...state,
        detail: {
          ...state.detail,
          content_message: state.detail.samples,
          reset: true
        }
      }
    default:
      throw new Error()
  }
}
